import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class servicesUrl {
  public url = 'https://api2.newtouch.sa';
}
